module.exports = __webpack_public_path__ + "img/logo_bpjs.2d75ee9b.svg";